export default "__VITE_ASSET__BeeRqbLh__"